import React from "react";

export default function SummaryBar({ items = [] }) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-slate-50 p-4">
      <div className={`grid grid-cols-1 gap-3 ${items.length >= 3 ? "sm:grid-cols-3" : "sm:grid-cols-2"}`}>
        {items.map((i) => (
          <div key={i.label} className="rounded-xl bg-white px-4 py-3 ring-1 ring-gray-200">
            <div className="text-xs font-semibold text-slate-500">{i.label}</div>
            <div className="mt-1 text-sm font-semibold text-[#0b2b40]">{i.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
